function NACEnd() {
  return <h3 className="not_displayed" id="winner_statment"></h3>;
}

export default NACEnd;
